import { MAIN_ACTION } from '../../constants/actions'

const getWallet = () => ({
  type: MAIN_ACTION.GET_WALLET
})

const getWalletSuccess = (data) => ({
  type: MAIN_ACTION.GET_WALLET_SUCCESS,
  payload: data
})

const getWalletFailed = (error) => ({
  type: MAIN_ACTION.GET_WALLET_FAILED,
  payload: error
})

const getAccountWallet = (hardRefresh) => ({
  type: MAIN_ACTION.GET_ACCOUNT_WALLET,
  payload: { hardRefresh }
})

const getAccountWalletSuccess = (data) => ({
  type: MAIN_ACTION.GET_ACCOUNT_WALLET_SUCCESS,
  payload: data
})

const getAccountWalletFailed = (error) => ({
  type: MAIN_ACTION.GET_ACCOUNT_WALLET_FAILED,
  payload: error
})

const postReferralCode = () => ({
  type: MAIN_ACTION.POST_REFERRAL_CODE
})

const postReferralCodeSuccess = (data) => ({
  type: MAIN_ACTION.POST_REFERRAL_CODE_SUCCESS,
  payload: data
})

const postReferralCodeFailed = (error) => ({
  type: MAIN_ACTION.POST_REFERRAL_CODE_FAILED,
  payload: error
})

const changeMainState = (property, value) => ({
  type: MAIN_ACTION.CHANGE_STATE,
  payload: { property, value }
})

const updateData = (data) => ({
  type: MAIN_ACTION.UPDATE_DATA,
  payload: data
})

const resetMainState = () => ({
  type: MAIN_ACTION.RESET_STATE
})

const getRecentDeposits = () => ({
  type: MAIN_ACTION.GET_RECENT_DEPOSITS
})

const getRecentDepositsSuccess = (data) => ({
  type: MAIN_ACTION.GET_RECENT_DEPOSITS_SUCCESS,
  payload: data
})

const getRecentDepositsFailed = (error) => ({
  type: MAIN_ACTION.GET_RECENT_DEPOSITS_FAILED,
  payload: error
})

export {
  getWallet,
  getWalletSuccess,
  getWalletFailed,
  getAccountWallet,
  getAccountWalletSuccess,
  getAccountWalletFailed,
  postReferralCode,
  postReferralCodeSuccess,
  postReferralCodeFailed,
  changeMainState,
  updateData,
  resetMainState,
  getRecentDeposits,
  getRecentDepositsSuccess,
  getRecentDepositsFailed
}
